// src/api/innerCircleWins.ts

import { BASE_URL } from "../utils/config";
import { InnerCircleWinsPage, InnerCircleWinsSummary } from "../types/api";

/**
 * Fetches a page of anonymised Inner Circle wins (newest first).
 * @throws {Error} If the request fails.
 */
export async function fetchInnerCircleWins(
	limit = 12,
	offset = 0
): Promise<InnerCircleWinsPage> {
	const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
	const response = await fetch(`${BASE_URL}/inner-circle-wins?${params}`);
	if (!response.ok) {
		throw new Error(`Failed to fetch Inner Circle wins: ${response.status}`);
	}
	return (await response.json()) as InnerCircleWinsPage;
}

/**
 * Fetches the total prize value (dollars) and number of Inner Circle wins.
 * @throws {Error} If the request fails.
 */
export async function fetchInnerCircleWinsSummary(): Promise<InnerCircleWinsSummary> {
	const response = await fetch(`${BASE_URL}/inner-circle-wins/summary`);
	if (!response.ok) {
		throw new Error(`Failed to fetch Inner Circle wins summary: ${response.status}`);
	}
	return (await response.json()) as InnerCircleWinsSummary;
}
